import { Box, Button, CssBaseline, Grid, Stack } from '@mui/material';
import { memo, ReactNode } from 'react';

interface ProjectLayoutProps {
  children: ReactNode;
  onSave: () => void;
  onPrev: () => void;
  type: 'regist' | 'modify';
}

function DiagnosticLayout({ children, onSave, onPrev, type }: ProjectLayoutProps): JSX.Element {
  return (
    <Box sx={{ display: 'flex' }}>
      <CssBaseline />
      <Grid container>{children}</Grid>
      <Stack
        direction="row"
        spacing={4}
        justifyContent="flex-end"
        sx={{
          display: 'flex',
          position: 'absolute',
          bottom: '12px',
          right: '24px',
          height: 40,
        }}
      >
        <Button
          onClick={onPrev}
          sx={theme => ({
            width: 100,
            backgroundColor: 'mind.grey.A0',
            color: 'text.primary',
            border: `1px solid ${theme.palette.mind.grey.disabled}`,
            borderRadius: '4px',
            ':hover': {
              backgroundColor: 'mind.custom.greyHover',
            },
          })}
        >
          이전
        </Button>
        <Button color="primary" variant="contained" onClick={onSave} sx={{ width: 100 }}>
          {type === 'regist' ? '문항 등록' : '저장'}
        </Button>
      </Stack>
    </Box>
  );
}

export default memo(DiagnosticLayout);
